import { Box, Button, FormControl, FormHelperText, FormLabel, Input } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { useForm } from 'react-hook-form'
import { ScoresContext } from '../routes/ScoreListing'

interface FormData {
  weekUrl: string
}

function SubmitWeekUrl() {
  const context = useContext(ScoresContext)

  const { register, handleSubmit } = useForm<FormData>()

  if (!context) {
    return <div>Loading...</div>
  }

  const { weekNum, setWeekUrlSubmitted, createNewFirestoreWeek } = context

  const onSubmit = async (data: FormData) => {
    await createNewFirestoreWeek(data.weekUrl, parseInt(weekNum))
    setWeekUrlSubmitted(true)
  }

  return (
    <Box p={10}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl>
          <FormLabel>Current week forum url for week {weekNum}</FormLabel>
          <Input type="url" {...register('weekUrl', { required: true })} />
          <FormHelperText>
            Copy the url of the current week from the forum. Paste the whole url (with https)
          </FormHelperText>
        </FormControl>
        <Button colorScheme="green" type="submit">
          Submit
        </Button>
      </form>
    </Box>
  )
}

export default SubmitWeekUrl
